export type ImgixSource = string;

export type ImgixW = number;

export type ImgixH = number;

export enum ImgixBG {
  Black = '000',
  Gray = 'D7D7D7',
  White = 'FFF',
}

export enum ImgixFit {
  Fill = 'fill',
  Crop = 'crop',
  Max = 'max',
}

export enum ImgixCrop {
  Faces = 'faces',
  Focalpoint = 'focalpoint',
}

export type ImgixOptions = {
  w: ImgixW;
  h: ImgixH;
  bg?: ImgixBG;
  crop?: ImgixCrop;
  fit?: ImgixFit;
};

/**
 * Uses the imgix formatting options documented here: https://docs.imgix.com/apis/url/format
 *
 * @param source e.g. "https://clutter.imgix.net/abc/def.jpg"
 * @param options e.g. { w: 480, h: 480, fit: 'fill', bg: 'FFF', crop: 'faces' }
 *
 * @returns e.g. "https://clutter.imgix.net/abc/def.jpg?w=480&h=480&fit=fill&bg=FFF&crop=faces&auto=compress&auto=format"
 */
export const imgixURL = (source: ImgixSource, options: ImgixOptions): string => {
  const params = new URLSearchParams();

  params.set('w', String(options.w));
  params.set('h', String(options.h));

  if (options.fit) params.set('fit', options.fit);
  if (options.bg) params.set('bg', options.bg);
  if (options.crop) params.set('crop', options.crop);

  params.append('auto', 'compress');
  params.append('auto', 'format');

  return `${source}?${String(params)}`;
};
